import React from 'react';

interface CardProps {
  children: React.ReactNode;
  loading?: boolean;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
  'data-testid'?: string;
}

const MetronicCard: React.FC<CardProps> = ({ children, loading = false, className = '', style, id, ...rest }) => {
  return (
    <div
      className={`card ${loading ? 'overlay overlay-block' : ''} ${className}`}
      data-testid={rest['data-testid']}
      id={id}
      style={style}
    >
      <div className="overlay-wrapper w-100 h-100">
        {children}
        {loading === true && (
          <div className="overlay-layer card-rounded bg-dark bg-opacity-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetronicCard;
